import { api } from "./api";

export async function fetchRealtimeToken(obsToken = null) {
    try {
        const { data } = await api.post(
            "/realtime-token",
            { expiresIn: 600, maxSessionDuration: 600 },
            obsToken ? { headers: { "X-OBS-Token": obsToken } } : undefined
        );
        return data; // { apiKey, expiresAt }
    } catch (e) {
        const detail = e.response?.data?.detail;
        if (detail === "no_credits") {
            throw new Error("Out of credits — top up in your console to start streaming.");
        }
        if (e.response?.status === 401) {
            throw new Error("Please log in to start streaming.");
        }
        throw e;
    }
}

export async function listPresets() {
    const { data } = await api.get("/presets");
    return data;
}

export async function createPreset(label, prompt) {
    const { data } = await api.post("/presets", { label, prompt });
    return data;
}

export async function deletePreset(id) {
    await api.delete(`/presets/${id}`);
}

export const PRESET_STYLES = [
    {
        id: "anime",
        label: "Anime Studio",
        prompt:
            "Transform into a hand-painted anime character, cel-shaded style with bold ink outlines, soft pastel color palette, large expressive eyes, dreamy cinematic lighting",
        thumb: "https://static.prod-images.emergentagent.com/jobs/bd3207ef-ee5e-4d93-accc-3f9c77fbe4a8/images/0309d929a82469d2144af374d847212836977598e6fbc143090bff927fd67333.png",
    },
    {
        id: "cyberpunk",
        label: "Neon City",
        prompt:
            "Cyberpunk character, glowing neon signage reflections, holographic visor, slick wet street ambience, magenta and cyan rim lighting, dystopian futuristic mood",
        thumb: "https://static.prod-images.emergentagent.com/jobs/bd3207ef-ee5e-4d93-accc-3f9c77fbe4a8/images/7272cb9574c70658a5c63bf7969274e23d732cfa5cd22aff55fed40e7f5d81dc.png",
    },
    {
        id: "oil",
        label: "Classical Oil",
        prompt:
            "Renaissance oil painting portrait, dramatic chiaroscuro lighting, rich earthy palette, textured brushwork on canvas, museum-quality fine art rendering",
        thumb: "https://static.prod-images.emergentagent.com/jobs/bd3207ef-ee5e-4d93-accc-3f9c77fbe4a8/images/bb91a9e95b892fcc484b19908d44ee07cd5274fb8128a0b0330922d611043231.png",
    },
    {
        id: "clay",
        label: "Claymation",
        prompt:
            "Stop-motion claymation character, sculpted plasticine textures, visible fingerprint marks, oversized cartoonish features, warm hand-crafted miniature-set lighting",
        thumb: "https://static.prod-images.emergentagent.com/jobs/bd3207ef-ee5e-4d93-accc-3f9c77fbe4a8/images/cce2cefac8ce527c870d814d458e8dba67d6a20b986164f0eac2cf6612146ce2.png",
    },
];
